import pick from 'lowscore/pick.js'
import sum from 'root-core/utils/array/sum.js'
import roundMoney from './roundMoney.js'
import TravelProtectionPlanType from 'root-packages/travelProtection/index.js'

export default class PerPassengerPrices {
  constructor (prices) {
    this.prices = prices
  }

  prepaidGratuities (passenger) {
    var gratuity
    if (passenger.prepaidGratuities && this.prices.prepaidGratuities) {
      gratuity = {
        ...pick(
          this.prices.prepaidGratuities,
          'productCode',
          'productId',
          'associatedProductId',
          'typeCode',
          'category'
        ),
        amount: this.prices.prepaidGratuities[passenger.type == 'adult' ? 'adultPrice' : 'childPrice'],
      }
    }
    return gratuity
  }

  travelProtectionPlan (passengerTotal, passengerIsOnatarioResident, o_planType) {
    const planType = o_planType === undefined ? TravelProtectionPlanType.standard : o_planType
    if (this.prices.travelProtectionPlans) {
      const plan = this.prices.travelProtectionPlans.find(({passengerTotalWindow, productCode, forOntario}) => {
        return (planType
          ? productCode.includes(planType)
          : !productCode.includes(TravelProtectionPlanType.plus)
        )
        && (typeof passengerTotalWindow.from === 'undefined' || passengerTotal >= passengerTotalWindow.from)
        && (typeof passengerTotalWindow.upto === 'undefined' || passengerTotal <= passengerTotalWindow.upto)
        && forOntario == !!passengerIsOnatarioResident
      })
      if (plan) {
        return plan
      }
      if (planType === TravelProtectionPlanType.standard) {
        return this.travelProtectionPlan(passengerTotal, passengerIsOnatarioResident, '')
      }
    }
  }

  travelProtectionPlanPlus (passengerTotal, passengerIsOnatarioResident) {
    return this.travelProtectionPlan(passengerTotal, passengerIsOnatarioResident, TravelProtectionPlanType.plus)
  }

  mandatoryProducts (passenger) {
    return (this.prices.mandatoryProducts || []).map(product => {
      var price
      if (passenger.type == 'adult') {
        price = product.adultPrice
      } else {
        price = product.childPrice
      }
      return {
        productName: product.productName,
        productCode: product.productCode,
        price,
        category: product.category,
        typeCode: product.typeCode,
      }
    })
  }

  mandatoryTravelProtection () {
    const mandatoryTravelProtection = (this.prices.travelProtectionPlans || []).find(
      p => p.isMandatory
    )
    if (mandatoryTravelProtection) {
      return {
        productCode: mandatoryTravelProtection.productCode,
        price: mandatoryTravelProtection.price,
        category: mandatoryTravelProtection.category,
        typeCode: mandatoryTravelProtection.typeCode,
      }
    }
  }

  foodFunds () {
    return sum(this.prices.foodFunds.map(ff => ff.price))
  }

  taxes (passenger, basicRoomPrice) {
    return sum(
      this.allTaxes(passenger, basicRoomPrice).map(tax => {
        return tax.price
      })
    )
  }

  allTaxes (passenger, basicRoomPrice) {
    return this.prices.taxes.map(tax => {
      var price = 0
      if (tax.percent) {
        price = roundMoney(basicRoomPrice * tax.percent / 100)
      } else {
        if (passenger.type == 'adult') {
          price = tax.adultPrice
        } else {
          price = tax.childPrice
        }
      }
      return {
        name : tax.name,
        price : price,
      }
    })
  }
}
